import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import { SvgIconProps, useTheme } from "@mui/material";

export const UnderlineIcon: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <FormatUnderlinedIcon {...props} style={{ color: theme.palette.brandedTypography.textColor }} />
  );
};

export default UnderlineIcon;
